module.exports = __webpack_public_path__ + "img/modernfit.96a26f5d.svg";